// Merge a course's start/finish line overrides over the card-level line for the
// preview chart. Every field a course can override must be carried through —
// including the offset ANGLE, else the chart falls back to default
// downwind/upwind and ignores a configured bearing. (ra-etwi)
export function mergePreviewStartFinish(course, cardLine) {
  if (!course) return cardLine;
  return {
    startType: course.startType ?? cardLine.startType,
    startMarkA: course.startMarkA ?? cardLine.startMarkA,
    startMarkB: course.startMarkB ?? cardLine.startMarkB,
    startOffsetNm: course.startOffsetNm ?? cardLine.startOffsetNm,
    startOffsetAngle: course.startOffsetAngle ?? cardLine.startOffsetAngle,
    finishType: course.finishType ?? cardLine.finishType,
    finishMarkA: course.finishMarkA ?? cardLine.finishMarkA,
    finishMarkB: course.finishMarkB ?? cardLine.finishMarkB,
    finishOffsetNm: course.finishOffsetNm ?? cardLine.finishOffsetNm,
    finishOffsetAngle: course.finishOffsetAngle ?? cardLine.finishOffsetAngle,
  };
}
